import { ListGroup, Row, Col, Badge } from 'react-bootstrap';
import { Water, LifePreserver, Recycle } from 'react-bootstrap-icons';

import { FMUpstreamIcon, FMDownstreamIcon } from './FloodMapperIcons.js';

import StationLinker from './StationLinker.js';
import StationMetricTypeIcon from './StationMetricTypeIcon.js';
import { sendClickNearByStationButton } from './GoogleAnalytics.js';

import GoverningBodyFlag from './GoverningBodyFlag.js';

function NearbyStationEntry({ nbStation, type }) {
	const isUpstreamDownstream = type === 'downstream' || type === 'upstream';
	return <StationLinker stationId={nbStation.stationId} urlSlug={nbStation.urlSlug} key={nbStation.stationId} onClick={function() {
		let submitType = type ? type : "station";
		sendClickNearByStationButton(submitType);
	}}>
		<ListGroup.Item style={{"cursor": "pointer"}} style={{overflow: "hidden"}}>
			<Row>
				<Col xs={2} xl={1}>
					{type === 'upstream' ? <FMUpstreamIcon /> : null}
					{type === 'downstream' ? <FMDownstreamIcon /> : null}
					{!isUpstreamDownstream ? <StationMetricTypeIcon qualifier={nbStation.stationPrimaryMetricType} /> : null}
				</Col>
				<Col xs={8} xl={9}>
					{nbStation.stationName}
				</Col>
				<Col xs={2} xl={2} style={{overflow: "hidden"}}>
					<GoverningBodyFlag governingBody={nbStation.governingBody} />
				</Col>
			</Row>
		</ListGroup.Item>
	</StationLinker>;
}

function NearByStationsComponent({ headingText, stations, excludeId, overrideIncludeTypes, upstreams, downstreams }) {
	const upstreamsList = upstreams && Array.isArray(upstreams) ? upstreams : [];
	const downstreamsList = downstreams && Array.isArray(downstreams) ? downstreams : [];

	if(!stations) { return null; }

	let includeTypes = ['Stage', 'Downstream Stage', 'Tidal', 'Groundwater Level', 'Rainfall'];
	if(overrideIncludeTypes) {
		includeTypes = overrideIncludeTypes;
	}

	let stationComponents = stations.reduce(function(acca, nbStation) {
		if(includeTypes.indexOf(nbStation.stationPrimaryMetricType) < 0) {
			return acca;
		}

		if(nbStation.stationId !== excludeId) {

			let targetArr = acca.stations;
			let type = 'station';
			if (upstreamsList.find(station => station.stationId === nbStation.stationId)) {
				return acca;
			} else if (downstreamsList.find(station => station.stationId === nbStation.stationId)) {
				return acca;
			}

			targetArr.push(<NearbyStationEntry nbStation={nbStation} type={type} />)
		}
		return acca;
	}, {
		upstreams: [],
		downstreams: [],
		stations: []
	});

	// Upstreams
	stationComponents.upstreams = upstreamsList.reduce(function(acca, nbStation) {
		if(includeTypes.indexOf(nbStation.stationPrimaryMetricType) < 0) {
			return acca;
		}
		acca.push(<NearbyStationEntry nbStation={nbStation} type="upstream" />);
		return acca;
	}, [])
	// Downstreams
	stationComponents.downstreams = downstreamsList.reduce(function(acca, nbStation) {
		if(includeTypes.indexOf(nbStation.stationPrimaryMetricType) < 0) {
			return acca;
		}
		acca.push(<NearbyStationEntry nbStation={nbStation} type="downstream" />);
		return acca;
	}, [])

	if(stationComponents.stations.length + stationComponents.upstreams.length + stationComponents.downstreams.length === 0) {
		stationComponents.stations.push(<ListGroup.Item><i>No nearby stations</i></ListGroup.Item>);
	}

	return <ListGroup>
		<ListGroup.Item variant="dark" className="bg-dark text-white">
		{headingText && headingText}
		{!headingText && "Other Nearby Stations"}
		</ListGroup.Item>
		{stationComponents.upstreams}
		{stationComponents.downstreams}
		{stationComponents.upstreams.length+stationComponents.downstreams.length > 0 ? <div style={{display: 'block', height: "2px", backgroundColor: "grey"}} /> : null}
		{stationComponents.stations}
	</ListGroup>;
}

export default NearByStationsComponent;